export default function Sine() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="15"
      viewBox="0 0 102.795 57.906"
    >
      <g id="sine" transform="translate(-10 -144.169)">
        <g id="Gruppe_1" data-name="Gruppe 1" transform="translate(10 144.169)">
          <path
            id="Pfad_1"
            data-name="Pfad 1"
            d="M12.728-366.682a3.3,3.3,0,0,0-2.288,1.482l-.441.7v26.648c0,22.269.042,26.746.294,27.185a3.845,3.845,0,0,0,2.078,1.563c.42.13,15.32.179,49.064.179,40.229,0,48.581-.033,49.147-.228a3.645,3.645,0,0,0,2.141-1.921c.063-.293.084-12.518.063-27.169l-.063-26.616-.566-.667a3.86,3.86,0,0,0-1.364-.96c-.776-.309-2.057-.309-49.063-.342C30.125-366.845,13.211-366.8,12.728-366.682Zm30.954,6.561c8.142,1.335,15.844,9.2,20.566,21.016,2.623,6.561,5.415,11.037,9.087,14.57a14.863,14.863,0,0,0,5.289,3.387,7.265,7.265,0,0,0,3.588.586,7.307,7.307,0,0,0,3.672-.635c3.274-1.253,6.8-4.509,9.674-8.954a55.957,55.957,0,0,0,3.735-6.9l.357-.846h3.232c2.938,0,3.232.033,3.232.277a47.913,47.913,0,0,1-3.274,7.163c-4.68,8.35-10.661,13.478-17.293,14.813a22.947,22.947,0,0,1-6.505.065,23.372,23.372,0,0,1-6.065-2.279c-5.834-3.369-11.249-10.516-14.627-19.307-2.414-6.3-6.463-12.242-10.346-15.237-3.735-2.881-7.366-3.516-11.312-2-4.511,1.726-9.4,7.456-12.864,15.123l-.587,1.3-3.274.049c-2.812.033-3.253,0-3.253-.212a16.9,16.9,0,0,1,.86-2.247c3.567-8.269,8.919-14.846,14.543-17.841a21.2,21.2,0,0,1,5.456-1.889A21.327,21.327,0,0,1,43.682-360.121Z"
            transform="translate(-10 366.831)"
          />
        </g>
      </g>
    </svg>
  );
}
